/**
 * The registry for SVG icon instances being used within the current context.
 */
var TylerIconRegistry = /** @class */ (function () {
    function TylerIconRegistry() {
    }
    /**
     * Defines a new Tyler icon.
     * @param icon The icon(s) to register.
     */
    TylerIconRegistry.define = function (icon, svgData) {
        if (Array.isArray(icon)) {
            return icon.filter(function (i) { return TylerIconRegistry._isIconObject(i); })
                .forEach(function (i) { return TylerIconRegistry._icons.set(i.name, i.data); });
        }
        var _a = TylerIconRegistry._parseIcon(icon, svgData), name = _a.name, data = _a.data;
        TylerIconRegistry._icons.set(name, data);
    };
    /**
     * Removes a defined Tyler icon.
     * @param icon The icon to unregister.
     */
    TylerIconRegistry.remove = function (icon) {
        var key = TylerIconRegistry._isIconObject(icon) ? icon.name : icon;
        TylerIconRegistry._icons.delete(key);
    };
    /**
     * Removes all defined icons.
     */
    TylerIconRegistry.clear = function () {
        TylerIconRegistry._icons.clear();
    };
    /**
     * Gets the icon data by its name, or `undefined` if not found.
     */
    TylerIconRegistry.get = function (name) {
        return TylerIconRegistry._icons.get(name);
    };
    /**
     * Gets the names of registered icons.
     */
    TylerIconRegistry.getIconNames = function () {
        return Array.from(TylerIconRegistry._icons.keys());
    };
    Object.defineProperty(TylerIconRegistry, "size", {
        /** Gets the number of defined icons in the registry. */
        get: function () {
            return TylerIconRegistry._icons.size;
        },
        enumerable: true,
        configurable: true
    });
    /** Normalizes incoming parameters to an `ITylerSvgIcon` type. */
    TylerIconRegistry._parseIcon = function (icon, data) {
        if (data === void 0) { data = ''; }
        if (TylerIconRegistry._isIconObject(icon)) {
            return icon;
        }
        return { name: icon, data: data };
    };
    /** Determines if the provided `icon` matches the `ITylerSvgIcon` shape. */
    TylerIconRegistry._isIconObject = function (icon) {
        return typeof icon === 'object' && icon.hasOwnProperty('name') && icon.hasOwnProperty('data');
    };
    TylerIconRegistry._icons = new Map();
    return TylerIconRegistry;
}());
export { TylerIconRegistry };
